import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import OrderDetails from "./OrderDetails";
import PanelTable from "../../../shares/PanelTable";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";
import { useNavigate } from "react-router-dom";
import PrintOrderDetailNavigator from "../PrintOrderDetailNavigator";

const headersList = [
  { colName: "code", name: "سند" },
  { colName: "date", name: "تاریخ تحویل سفارش" },
  { colName: "details", name: "جزییات سفارش" },
  { colName: 'print', name: 'چاپ سفارش' },

];

const mobileHeadersList = [
  { colName: "code", name: "سند" },
  { colName: "date", name: "تاریخ تحویل سفارش" },
];

const dataKey = ["unique_id", "created_at"];

const CanceledOrders = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [codeFilter, setCodeFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const { userData } = useUserData();
  const navigate = useNavigate();

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [removedOerdersList, setRemovedOerdersList] = useState({
    results: [],
  });

  const getRemovedOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/customer_get_cancel_order`,
    params: { unique_id: codeFilter },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRemovedOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails
          selectedRow={it}
          getRemovedOrderApi={getRemovedOrderApi}
        />
      ),
    },
  ];

  const actionsList = [   {
    label: "چاپ",
    component: (it) => <PrintOrderDetailNavigator inCurrentOrder selectedRow={it} />,
  },];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    if (codeFilter !== null) {
      setIsFilterOn(true);
      getRemovedOrderApi.reFetch();
    }
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getRemovedOrderApi.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRemovedOerdersList({ results: [] });

    getRemovedOrderApi.reFetch();
  };
  const handelPrintReport = () => {
    // navigate(`/print-current-orders/cancel/${codeFilter}/`);
    window.open(
      `/print-current-orders/cancel/${codeFilter}/`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="cancelled-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های لغو شده</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های لغو شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={removedOerdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
            setSelectedRow={setSelectedRow}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default CanceledOrders;
